import React, { useLayoutEffect, useId, useRef, useCallback } from "react";
import "./tempusdominus-setup";
import $ from "jquery";
import moment from "moment";

const DATETIME_FORMAT = "M/D/YYYY h:mm A";

const Bootstrap4DatePickerComponent = ({
  setSelectedDate,
  defaultDate,
  pickerId: pickerIdProp,
  inputId: inputIdProp,
}) => {
  const wrapperRef = useRef(null);
  const autoId = useId().replace(/:/g, "");
  const wrapperDomId = pickerIdProp || `td-picker-${autoId}`;
  const inputDomId = inputIdProp || `td-input-${autoId}`;

  const getWrapper = useCallback(() => {
    const el = wrapperRef.current;
    return el ? $(el) : null;
  }, []);

  const togglePicker = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      const $wrapper = getWrapper();
      if ($wrapper?.data("datetimepicker")) {
        $wrapper.datetimepicker("toggle");
      }
    },
    [getWrapper]
  );

  const showPicker = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      const $wrapper = getWrapper();
      if ($wrapper?.data("datetimepicker")) {
        $wrapper.datetimepicker("show");
      }
    },
    [getWrapper]
  );

  useLayoutEffect(() => {
    const $wrapper = getWrapper();
    if (!$wrapper?.length) return;

    // Purge any stale handlers left by HMR fast-refresh or incomplete prior cleanup
    $wrapper.find("input").off(".datetimepicker");
    if ($wrapper.data("datetimepicker")) {
      $wrapper.datetimepicker("destroy");
    }

    $wrapper.datetimepicker({
      format: DATETIME_FORMAT,
      allowInputToggle: false,
      defaultDate: defaultDate ? moment(defaultDate) : moment(),
      icons: {
        time: "fa fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down",
        previous: "fa fa-chevron-left",
        next: "fa fa-chevron-right",
        today: "fa fa-calendar-check-o",
        clear: "fa fa-trash",
        close: "fa fa-times",
      },
    });

    const onChange = (e) => {
      if (e.date) {
        setSelectedDate(e.date.toDate());
      }
    };

    $wrapper.on("change.datetimepicker", onChange);

    return () => {
      $wrapper.off("change.datetimepicker", onChange);
      $wrapper.find("input").off(".datetimepicker");
      if ($wrapper.data("datetimepicker")) {
        $wrapper.datetimepicker("destroy");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    const $wrapper = getWrapper();
    if (!$wrapper?.length || !defaultDate || !$wrapper.data("datetimepicker")) return;
    $wrapper.datetimepicker("date", moment(defaultDate));
  }, [defaultDate, getWrapper]);

  return (
    <div className="form-group mb-0">
      <div
        ref={wrapperRef}
        className="input-group date site_family"
        id={wrapperDomId}
        data-target-input="nearest"
      >
        <input
          type="text"
          id={inputDomId}
          className="form-control datetimepicker-input datee site_family"
          data-target={`#${wrapperDomId}`}
          readOnly
          onClick={showPicker}
          style={{ fontSize: "16px" }}
        />
        <div className="input-group-append" onClick={togglePicker}>
          <div className="input-group-text">
            <i className="fa fa-calendar" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bootstrap4DatePickerComponent;
